import React, { useRef, useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';

const defaultLocation = { lat: 20.5937, lng: 78.9629 }; // Example coordinates for India
const zoom = 4;

const MapComponent = ({ userData }) => {
    let locations = [];
    if (userData?.deviceList.length > 0) {
        for (const loc of userData.deviceList) {
            const l = {
                lat: parseFloat(loc.lat),   // Parse latitude as a float
                lng: parseFloat(loc.lon),   // Parse longitude as a float
                device: loc.name            // Get the device name
            };
            locations.push(l);  // Push each object into the locs array
        }
    }
    console.log(locations)

    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAP_KEY
    });

    const mapRef = useRef(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [infoWindowContent, setInfoWindowContent] = useState('');

    const onLoad = (map) => {
        mapRef.current = map;
    };

    const onUnmount = () => {
        mapRef.current = null;
    };

    const handleMarkerClick = (location) => {
        setSelectedLocation(location);
        setInfoWindowContent(location.device); // Set the content of the InfoWindow to device name
    };

    if (loadError) {
        return <div>Error loading Google Maps API</div>;
    }

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={{ width: '100%', height: '400px' }}
            center={locations.length > 0 ? locations[0] : defaultLocation}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
                disableDefaultUI: true, // Disable default UI controls
                mapTypeControl: false,  // Disable map type control
            }}
        >
            {locations.map((location, index) => (
                <Marker
                    key={index}
                    position={{ lat: location.lat, lng: location.lng }}
                    onClick={() => handleMarkerClick(location)}
                />
            ))}

            {selectedLocation && (
                <InfoWindow
                    position={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
                    onCloseClick={() => setSelectedLocation(null)}
                >
                    <div>{infoWindowContent}</div>
                </InfoWindow>
            )}
        </GoogleMap>
    ) : (
        <div>Loading...</div>
    );
};

export default MapComponent;
